import styled from 'styled-components';
import { NoSlotsMessage } from 'components/shared/NoSlotsMessage';

export const NoSlotsMessagePreview = styled(NoSlotsMessage)`
    background-color: ${(props) => props.theme.semiWhite};
    border-radius: 8px;
`;
